import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GenderData } from "../../../../../data";
import toast from "react-hot-toast";
import { save } from "../../../../../features/save/saveSlice";
import { setActiveObj } from "../../../../../features/obj/objSlice";

const SubsidyModal = ({ isModalOpen, handleCancel, handleFetch }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { user } = useSelector((state) => state.auth);
  const { subsidySources, subsidyTypes } = useSelector((state) => state.fetch);
  const { activeObjexpIsp } = useSelector((state) => ({
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
  }));
  
 
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const onFinish = async (data) => {
    data.projectBidId = activeObjexpIsp?.projectBidId
      ? activeObjexpIsp?.projectBidId
      : null;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/flid/projects/setProjectSubsidy",
      })
    ); 
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
        await dispatch(setActiveObj({ key: "expressionIsp", data: res?.payload?.data?.result }));
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };
 
useEffect(() => {
  if (!form || !activeObjexpIsp || Object.keys(activeObjexpIsp)?.length === 0) return;

  requestAnimationFrame(() => {
    form.setFieldsValue(activeObjexpIsp);
  });
}, [activeObjexpIsp]);

 
  return (
    <>
      <Modal
        className=""
        title={"Subsidy Configuration"}
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel}
        width={750}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=""
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="projectSubsidyTypeId"
            className=""
            label={"Subsidy Type"}
            rules={[
              {
                required: true,
                message: "Please select subsidy type",
              },
            ]}
          >
            <Select
              placeholder="Select"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                subsidyTypes?.length > 0 &&
                subsidyTypes?.map((item) => ({
                  value: item?.subsidyTypeId,
                  label: item?.subsidyTypeName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="projectSubsidySourceId"
            className=""
            label={"From"}
            rules={[
              {
                required: true,
                message: "Please select From",
              },
            ]}
          >
            <Select
              placeholder="Select"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                subsidySources?.length > 0 &&
                subsidySources?.map((item) => ({
                  value: item?.subsidySourceId,
                  label: item?.subsidySourceName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="projectSubsidyDetails"
            label="Details"
            rules={[
              {
                required: true,
                message: "Please add details",
              },
            ]}
          >
            <Input placeholder="details" className="input" />
          </Form.Item>

          <Form.Item
            name="projectSubsidy"
            label={"Amount"}
            rules={[
              {
                required: true,
                message: "Please add amount",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              placeholder="KES: e.g 500,000.00"
              className="input flex"
            />
          </Form.Item>

          <div className="flex justify-between mt-[1.75rem] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center  gap-x-5">
              <div className="w-[100px] ">
                <button
                  type="button"
                  key="back"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[100px]">
                <button
                  disabled={saving}
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                >
                  {saving ? <Spin /> : "Save"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default SubsidyModal;
